import React from 'react';
import { Typography } from '@material-ui/core';

// import stageClipIcon from 'assets/stageClipIcon.svg';
import { useStyles } from './ParticipantSelectionHeader.styles';
import { Image } from 'shared/components';
import { useLocale } from 'shared/hooks';
import { ParticipantSelectionHeaderProps } from './ParticipantSelectionHeader.types';

export const ParticipantSelectionHeader = ({ studentName, institutionLogo }: ParticipantSelectionHeaderProps) => {
  const styles = useStyles();
  const { formatMessage } = useLocale();

  //   const onRedirectSubmit = () => {
  //     const supportURL = 'https://stageclip.com/student-support/';
  //     window.open(supportURL, '_blank');
  //   };
  // const asd = 'Emmanuel';
  //   const sliit =
  //     'https://clippingplatformstaging.blob.core.windows.net/public/accounts/1509231d-dc79-4685-91c5-d7ab5879c12d/logos/cb58f204-3d26-4e55-a532-c23ba3768429-InstitutionLogo-2a3748c1-fe74-4530-9fb9-08fbea0bc0dd.png';

  //   const emerson =
  //     'https://s3-alpha-sig.figma.com/img/0a75/9b3b/f8c29e760ebfe1361ed488eca01dc915?Expires=1729468800&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4&Signature=LPm~BY~rBIcf9fHWHvnXXCr994RDCM-Wsx1joGUVwT4Q8b~T7vOWUyE2KlmT1eHNuvFgMPhdn~VDiF8aCBY~gvOhhF-mg1QDN8QhJZ9tqF6Px1-ZsE3ZnsfTbPzaeFWLex7ZjQc-zey4F2ySz-D1aXG5cslD6dAM2KiYX-RppMJkOIsKcoqjGKT3Th6t2urBGk58x6HRPLw9~hYa7nSwvhVEunFt3dzGwbch8FnwOKqwnB3nZVDc3RpVIcR6N4TI9rIBpW~bAohXka~HtkgnsJ8G2FLiBswsZRCAHdF-bYqpPygBg7uSTVs2dt4B6Vrr12qiAQhRj9xu9d9a3QER3A__';\

  return (
    <div className={styles.container}>
      <div className={styles.logoContainer}>
        <Image className={styles.logoImage} alt="" src={institutionLogo} />
      </div>
      <Typography className={styles.congratsTitle}>
        {formatMessage({ id: 'studentSelection.selection.congrats.name' }, { studentName })}
      </Typography>
    </div>
  );
};
